"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_jss_1 = __importDefault(require("react-jss"));

var react_qr_reader_1 = __importDefault(require("react-qr-reader"));

var BurnerProvider_1 = require("../BurnerProvider");

var style = function style(theme) {
  return {
    overlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      padding: 15,
      display: 'flex',
      flexDirection: 'column',
      zIndex: 100
    },
    instruction: {
      textAlign: 'center',
      color: '#EEEEEE',
      fontSize: 16,
      marginTop: 16
    },
    cameraIconContainer: {
      display: 'flex',
      height: 100
    },
    cameraIcon: {
      flex: 1
    },
    readerContainer: {
      overflow: 'hidden'
    },
    reader: {
      flex: '1 0'
    }
  };
};

var Scanner = function Scanner(_a) {
  var children = _a.children,
      completeScan = _a.completeScan,
      classes = _a.classes;
  var reader = react_1.useRef(null);

  var _b = react_1.useState(false),
      fallback = _b[0],
      setFallback = _b[1];

  if (!completeScan) {
    return null;
  }

  return react_1.default.createElement("div", {
    className: classes.overlay
  }, react_1.default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return completeScan(null);
    }
  }, "Close"), fallback && react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("div", {
    className: classes.instruction
  }, "Take a photo of a QR code"), react_1.default.createElement("div", {
    className: classes.cameraIconContainer,
    onClick: function onClick() {
      return reader.current.openImageDialog();
    }
  }, react_1.default.createElement("svg", {
    className: classes.cameraIcon,
    viewBox: "0 0 24 24"
  }, react_1.default.createElement("path", {
    fill: "#ffffff",
    d: "M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z"
  })))), react_1.default.createElement("div", {
    className: classes.readerContainer
  }, react_1.default.createElement(react_qr_reader_1.default, {
    delay: 300,
    ref: reader,
    legacyMode: fallback,
    className: classes.reader,
    onError: function onError(err) {
      console.error(err);
      setFallback(true);
    },
    onScan: function onScan(address) {
      if (address) {
        completeScan(address);
      }
    }
  })));
};

exports.default = react_jss_1.default(style)(BurnerProvider_1.withBurner(Scanner));